import { Loading03Icon } from '@hugeicons/core-free-icons';
import { Icon } from './icon.js';
import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface SpinnerProps extends Omit<React.SVGAttributes<SVGSVGElement>, 'strokeWidth'> {
  strokeWidth?: number;
  /** When set, the spinner is announced (role=status) with this label. Otherwise it is decorative. */
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = { sm: 'size-4', md: 'size-5', lg: 'size-8' } as const;

export const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(function Spinner({ label, size = 'md', className, ...props }, ref) {
  const icon = <Icon icon={Loading03Icon} ref={ref} aria-hidden className={cn('animate-spin text-current', SIZES[size], className)} {...props} />;
  if (!label) return icon;
  return (
    <span role="status" className="inline-flex items-center gap-2">
      {icon}
      <span className="sr-only">{label}</span>
    </span>
  );
});
